module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":""},"en":{"title":"Do you want to secure more than 30 years of rent for your unused land?"},"it":{"title":"Vuoi avere una rendita sicura per oltre 30 anni da un tuo terreno non utilizzato?"},"lt":{"title":""},"pl":{"title":"Szukasz dodatkowego źródła dochodu na lata?"}}')
  delete Component.options._Ctor
}
